// Copyright (c) 2020 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';

const LaborRateRequest = props =>
    <div className='wip-labor-rate-rquest-item'>
        <div className='count'>
            {props.count}
        </div>
        <Link to={`/claims/labor-rates/request/details?status=${props.statusKey}`}>
            <FormattedMessage id={props.status}/>
        </Link>
        <div className='status-indicator'>
            <span className={props.className}/>
        </div>
    </div>;

LaborRateRequest.displayName = 'LaborRateRequest';
LaborRateRequest.propTypes = {
    className: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
    statusKey: PropTypes.string.isRequired
};

export default LaborRateRequest;



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/components/labor-rate-request.js